import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { BlockMaximumCount } from '../../../../../models/template/block-maximum-count.interface.';
import { BlockMinimumCount } from '../../../../../models/template/block-minimum-count.interface';
import { UniqueTextConstraint } from '../../../../../models/template/unique-text-constraint.interface';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

@Component({
    selector: 'app-gen-single-image-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/gen-single-image-template/"
      channelLabel="Google Gen Single Image"
      namePlaceholder="Enter Google Gen Single Image template name"
      emptyMessage="No Google Gen Single Image found!"
      heartbeatType="gen-single-image-template"
      [showSidePreview]="true"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [blockMaximumCount]="blockMaximumCount"
      [blockMinimumCount]="blockMinimumCount"
      [uniqueTextConstraints]="uniqueTextConstraints"
      [requiredFields]="requiredFields"
      />
  `
})
export class GenSingleImageTemplateComponent {
  protected readonly templateType = TypeEnum.GOOGLE_GEN_SINGLE_IMAGE;

  protected readonly blockMaximumCount: BlockMaximumCount[] = [
    // { blockName: "sitelink", limit: 20 },
    // { blockName: "rsa-search-image", limit: 1 },
    // { blockName: "rsa-search-callouts", limit: 1 },
  ];

  protected readonly blockMinimumCount: BlockMinimumCount[] = [
    // { blockName: "sitelink", treshold: 4 },
    // The image block has a delete button but cannot be re-added; images are required.
    { blockName: 'gen-single-image-image', treshold: 1 },
  ];

  protected readonly uniqueTextConstraints: UniqueTextConstraint[] = [
    { blockName: 'gen-single-image-headline', fields: ['GenSingleImageHeadline_'] },
    { blockName: 'gen-single-image-description', fields: ['GenSingleImageDescription_'] },
  ];

  // Image upload and dropdowns have no editor for the empty-field check to see.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'gen-single-image-image', field: 'GenSingleImageImage_', label: 'Image' },
    { blockName: 'gen-single-image-cta-text', field: 'Text', label: 'CTA' },
    { blockName: 'gen-single-image-logo', field: 'Logo', label: 'Logo' },
  ];

  // Order matters — mirrors the original push order for new templates.
  // `count` sets the starting instance index; omit it and it auto-increments per name.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    {
      name: 'gen-single-image-headline',
      count: 1,
      variables: { GenSingleImageHeadline_1: '', GenSingleImageHeadline_2: '', GenSingleImageHeadline_3: '' },
    },
    { name: 'gen-single-image-description', count: 1, variables: { GenSingleImageDescription_1: '', GenSingleImageDescription_2: '' } },
    { name: 'gen-single-image-image', count: 1, variables: { GenSingleImageImage_1: '' } },
    {
      name: 'gen-single-image-url',
      count: 1,
      variables: { Link: '' },
    },
    {
      name: 'gen-single-image-cta-text',
      count: 1,
      variables: { Text: '' },
    },
    {
      name: 'gen-single-image-logo',
      count: 1,
      variables: { Logo: '' },
    },
  ];
}
